import {
    // IconButton,
    Dialog,
    makeStyles,
    Slide,
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import React from 'react';
import { InvoiceFeesBilledInLastYearGroupedChart } from './FeesBilledInLastYear/InvoiceFeesBilledInLastYearGroupedChart';
import { ChartFilter, getSelectedItem } from './ChartComponents';
import { useHistory } from 'react-router-dom';
import { DrillDownType } from './DrillDownType';
import { BillingRealisationChart } from './BillingRealisation/BillingRealisationChart';
import CurrentMatterChart from './CurrentMatterChart';
import { UnbilledFeesChart } from './UnbilledFees/UnbilledFeesChart';
import { DebtOwingChart } from './DebtOwing/DebtOwingChart';
import { HoursRecordedByStaffMemberChart } from './HoursRecorded/HoursRecordedByStaffMemberChart';
import { NonBillableTimesByActivityChart } from './NonBillableTimes/NonBillableTimesByActivityChart';
import { NonBillableTimesByStaffChart } from './NonBillableTimes/NonBillableTimesByStaffChart';
import { ClientBillingChart } from './ClientBilling/ClientBillingChart';
import { BilledVsEstimateGroupedChart } from './BilledVsEstimate/BilledVsEstimateGroupedChart';
import { ClientExposureChart } from './clientExposure/ClientExposureChart';
import { FeesBilledMonthToDateGroupedChart } from '../home/FeesBilledMonthToDate/FeesBilledMonthToDateGroupedChart';
import { DebtorDaysChart } from './debtorDays/DebtorDaysChart';
import { FeesBilledVsBudgetByFeeEarnerChart } from './FeesBilled/FeesBilledVsBudgetByFeeEarnerChart';
import { FeesRecordedVsBudgetByFeeEarnerChart } from './Time/FeesRecordedVsBudgetByFeeEarnerChart';
import { ExpectedFutureFeesChart } from './ExpectedFutureFees/ExpectedFutureFeesChart';
import { TrustBalanceChart } from './trustBalance/TrustBalanceChart';
import { CombinedNewMattersChart } from './NewMatters/CombinedNewMattersChart';
import { NewMattersByPeriodsChart } from './NewMatters/NewMattersByPeriodsChart';
import { AverageMatterDurationChart } from './AverageMatterDuration/AverageMatterDurationChart';
import { TopReferrersByPeriodChart } from './Referrer/TopReferrersByPeriodChart';
import { WipLockupDaysChart } from './wipLockupDays/WipLockupDaysChart';
import { DueDatesByPersonChart } from './dueDates/DueDatesByPersonChart';
import { NewMattersInLastTwelveMonthsGroupedChart } from './NewMatters/NewMattersInLastTwelveMonthsGroupedChart';
import { MattersByCountryChart } from './mattersByCountry/MattersByCountryChart';
import { CurrentMattersByAustralianStatesChart } from './mattersByCountry/CurrentMattersByAustralianStatesChart';
import { FeatureLayout } from './FeatureLayoutRepository';
import { USMapChart } from './mattersByCountry/USMapChart';
import { BillableTimeByStaffChart } from './billableTime/BillableTimeByStaffChart';
import { FeesBilledVsBudgetByGroupChart } from './FeesBilled/FeesBilledVsBudgetByGroupChart';
import { KPISummaryExpandedChart } from './KPISummary/KPISummaryExpandedChart';
import { PhoneCallResponseTimeChart } from './tasks/PhoneCallResponseTimeChart';
import { TaskResponseTimeByAssigneeChart } from './tasks/TaskResponseTimeByAssigneeChart';
import { TaskResponseTimeByTaskTypeChart } from './tasks/TaskResponseTimeByTaskTypeChart';
import { AverageElapsedTimeByTaskTypeChart } from './tasks/AverageElapsedTimeByTaskTypeChart';
import { AverageElapsedTimeByAssigneeChart } from './tasks/AverageElapsedTimeByAssigneeChart';
import { WriteOffOnChart } from './writeOffOn/WriteOffOnChart';
import { CrmMatterBillingChart } from './matterBilling/CrmMatterBillingChart';
import { MatterProfitabilityByCategoryChart } from './MatterProfitability/MatterProfitabilityByCategoryChart';
import { EnquiryActivityByUserChart } from './enquiryActivity/EnquiryActivityByUserChart';
import { StaffUnbilledFeesChart } from './StaffUnbilledFees/StaffUnbilledFeesChart';

export const useStyles = makeStyles((theme) => ({
    root: {},
    dialogPaper: {
        position: 'relative',
    },
    printIconButton: {
        position: 'absolute',
        right: '70px',
        top: '10px',
        zIndex: 1,
    },
    chartContainer: {
        display: 'flex',
        flexFlow: 'column',
        flex: 1,
    },
}));

interface MaximizeChartDialogProps {
    open: boolean;
    onClose?: () => void;
    chartFilter: ChartFilter;
    selectedOption?: number;
    additionalOption?: number;
    onSelectedOption?: (option: number, additionalOption: number) => void;
    selectedFeatureLayout: FeatureLayout | null;
    maximizeSelected?: {
        // tslint:disable-next-line:no-any
        [key: string]: any;
    };
}

const SlideTransition = React.forwardRef(function Transition(props: TransitionProps & { children?: React.ReactElement }, ref: React.Ref<unknown>) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const MaximizeChartDialog: React.FC<MaximizeChartDialogProps> = (props) => {
    const classes = useStyles();

    const history = useHistory();

    // tslint:disable-next-line: no-any
    const onGetSelectedItem = (searchCriterias: any, isShowCompleted: boolean, title?: string, drillDownType?: DrillDownType, defaultView?: string) => {
        getSelectedItem(props.chartFilter, history, searchCriterias, isShowCompleted, title, drillDownType, defaultView);
    };

    const selectedChart = () => {
        if (props.selectedFeatureLayout?.feature === 'FeesBilledInLastYearByActingChart') {
            // 96
            return (
                <InvoiceFeesBilledInLastYearGroupedChart
                    groupBy="PersonActing"
                    onCloseChart={props.onClose}
                    getSelectedItem={onGetSelectedItem}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledInLastYearByResponsibleChart') {
            // 97
            return (
                <InvoiceFeesBilledInLastYearGroupedChart
                    groupBy="PersonResponsible"
                    onCloseChart={props.onClose}
                    getSelectedItem={onGetSelectedItem}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledInLastYearByMatterTypeChart') {
            // 98
            return (
                <InvoiceFeesBilledInLastYearGroupedChart
                    groupBy="MatterType"
                    onCloseChart={props.onClose}
                    getSelectedItem={onGetSelectedItem}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledInLastYearByMatterCategoryChart') {
            // 99
            return (
                <InvoiceFeesBilledInLastYearGroupedChart
                    groupBy="MatterCategory"
                    onCloseChart={props.onClose}
                    getSelectedItem={onGetSelectedItem}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledInLastYearByPropertyTypeChart') {
            // 100
            return (
                <InvoiceFeesBilledInLastYearGroupedChart
                    groupBy="PropertyType"
                    onCloseChart={props.onClose}
                    getSelectedItem={onGetSelectedItem}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledInLastYearByReportingGroupChart') {
            // 101
            return (
                <InvoiceFeesBilledInLastYearGroupedChart
                    groupBy="ReportingGroup"
                    onCloseChart={props.onClose}
                    getSelectedItem={onGetSelectedItem}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'BillingRealisationChart') {
            return (
                <BillingRealisationChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    selectedOption={props.selectedOption}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'MatterCountByActingChart') {
            // 25
            return (
                <CurrentMatterChart
                    groupBy="PersonActing"
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'UnbilledFeesByActingChart') {
            // 43
            return (
                <UnbilledFeesChart
                    groupBy="PersonActing"
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'DebtOwingByActingChart') {
            // 60
            return (
                <DebtOwingChart
                    groupBy="PersonActing"
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'HoursRecordedByStaffMembersChart') {
            return (
                <HoursRecordedByStaffMemberChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    selectedOption={props.selectedOption}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'NonBillableTimesByActivityChart') {
            return (
                <NonBillableTimesByActivityChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    selectedOption={props.selectedOption}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'NonBillableTimesByStaffChart') {
            return (
                <NonBillableTimesByStaffChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    selectedOption={props.selectedOption}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'BillableTimesByStaffChart') {
            return (
                <BillableTimeByStaffChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    selectedOption={props.selectedOption}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'ClientBillingChart') {
            return (
                <ClientBillingChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    selectedOption={props.selectedOption}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'BilledFeesVsEstimateByActingChart') {
            return (
                <BilledVsEstimateGroupedChart
                    groupBy="PersonActing"
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'ClientExposureChart') {
            return (
                <ClientExposureChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledMonthToDateByReportingGroupChart') {
            return (
                <FeesBilledMonthToDateGroupedChart
                    groupBy="ReportingGroup"
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    selectedOption={props.selectedOption}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'DebtorDaysByPersonActingChart') {
            return (
                <DebtorDaysChart
                    groupBy="PersonActing"
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'DebtOwingByClientChart') {
            return (
                <DebtOwingChart
                    groupBy="Client"
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledVsBudgetByFeeEarnerChart') {
            return (
                <FeesBilledVsBudgetByFeeEarnerChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesRecordedVsBudgetByFeeEarnerChart') {
            return (
                <FeesRecordedVsBudgetByFeeEarnerChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'ExpectedFutureFeesByActingChart') {
            return (
                <ExpectedFutureFeesChart
                    groupBy="PersonActing"
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'TrustBalanceChart') {
            return (
                <TrustBalanceChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    groupBy="Client"
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'CombinedNewMattersByCategoryChart') {
            return (
                <CombinedNewMattersChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'NewMattersByPeriodsChart') {
            return (
                <NewMattersByPeriodsChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'MatterDurationByCategoryOrTypeChart') {
            return (
                <AverageMatterDurationChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    selectedOption={props.selectedOption}
                    additionalOption={props.additionalOption}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'TopReferrersInLast12MonthsChart') {
            return (
                <TopReferrersByPeriodChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    period={'TwelveMonths'}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'WIPLockUpDaysByPersonActingChart') {
            return (
                <WipLockupDaysChart
                    groupBy="PersonActing"
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'DueDatesByPersonChart') {
            return (
                <DueDatesByPersonChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    selectedOption={props.selectedOption}
                    additionalOption={props.additionalOption}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'NewMattersInLastTwelveMonthsByReportingGroupChart') {
            return (
                <NewMattersInLastTwelveMonthsGroupedChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    groupBy="ReportingGroup"
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'MattersByCountryChart') {
            return (
                <MattersByCountryChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    maximizeSelected={props.maximizeSelected}
                />
            );
        }  else if (props.selectedFeatureLayout?.feature === 'CurrentMattersByAustralianStateChart') {
            return (
                <CurrentMattersByAustralianStatesChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'CurrentMattersByUSStateChart') {
            return (
                <USMapChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledVsBudgetByOfficeChart') {
            return (
                <FeesBilledVsBudgetByGroupChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    groupBy="Office"
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledVsBudgetByTeamChart') {
            return (
                <FeesBilledVsBudgetByGroupChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    groupBy="Team"
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'FeesBilledVsBudgetByDepartmentChart') {
            return (
                <FeesBilledVsBudgetByGroupChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    groupBy="Department"
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'KpiSummaryChart') {
            return (
                <KPISummaryExpandedChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    showScreenshot={true}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'PhoneCallResponseTimeChart') {
            return (
                <PhoneCallResponseTimeChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showScreenshot={true}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'TaskResponseTimeByAssignee') {
            return (
                <TaskResponseTimeByAssigneeChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showScreenshot={true}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'TaskResponseTimeByTaskType') {
            return (
                <TaskResponseTimeByTaskTypeChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showScreenshot={true}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'AverageElapsedTimeByTaskTypeChart') {
            return (
                <AverageElapsedTimeByTaskTypeChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showScreenshot={true}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'AverageElapsedTimeByAssigneeChart') {
            return (
                <AverageElapsedTimeByAssigneeChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showScreenshot={true}
                    showAllRecords={true}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'WriteOffOrOnAnalysisChart') {
            return (
                <WriteOffOnChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showScreenshot={true}
                    showAllRecords={true}
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'MatterBillingChart') {
            return (
                <CrmMatterBillingChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showScreenshot={true}
                    showAllRecords={true}
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'MatterProfitabilityByCategoryChart') {
            return (
                <MatterProfitabilityByCategoryChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'MatterProfitabilityByMatterTypeChart') {
            return (
                <MatterProfitabilityByCategoryChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    groupBy="MatterType"
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'MatterProfitabilityByPersonActingChart') {
            return (
                <MatterProfitabilityByCategoryChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    groupBy="PersonActing"
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'MatterProfitabilityByPersonResponsibleChart') {
            return (
                <MatterProfitabilityByCategoryChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    groupBy="PersonResponsible"
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'MatterProfitabilityByClientChart') {
            return (
                <MatterProfitabilityByCategoryChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    groupBy="Client"
                    maximizeSelected={props.maximizeSelected}
                />
            );
        } else if (props.selectedFeatureLayout?.feature === 'EnquiryActivityByUserChart') {
            return (
                <EnquiryActivityByUserChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    maximizeSelected={props.maximizeSelected}
                />
            )
        } else if (props.selectedFeatureLayout?.feature === 'StaffUnbilledFeesChart') {
            return (
                <StaffUnbilledFeesChart
                    getSelectedItem={onGetSelectedItem}
                    onCloseChart={props.onClose}
                    description={props.selectedFeatureLayout.description}
                    chartFilter={props.chartFilter}
                    showAllRecords={true}
                    infoUrl={props.selectedFeatureLayout.infoUrl}
                    maximizeSelected={props.maximizeSelected}
                />
            );
        }

        return <div />;
    };
    return (
        <Dialog
            fullScreen={true}
            open={props.open}
            onClose={props.onClose}
            TransitionComponent={SlideTransition}
            classes={{
                paper: classes.dialogPaper,
            }}
        >
            <div className={classes.chartContainer}>{selectedChart()}</div>
        </Dialog>
    );
};
